import reducer, { actions } from './slice';
import * as asyncActions from './asyncActions';

export const organizationBillingContactStore = {
  actions,
  asyncActions,
};

export default reducer;
